import { computed, defineComponent } from 'vue'
import type { CheckboxInputProps } from './types'
import CheckedIcon from 'assets/img/svg/icons/checked.svg?url'
import { toBoolean } from '@/utils/boolean'
import Icon from 'components/icon'
import { tv } from 'tailwind-variants'

const CheckboxInputClass = tv({
  base: 'w-4 h-4 bg-primary-800 cursor-pointer border border-primary-500 items-center justify-center text-center text-white',
  variants: {
    color: {
      blue800: 'border-primary-500 bg-transparent',
      gray: 'border-gray-900 bg-transparent text-gray-900',
      gray300: 'border-gray-300 bg-white text-gray-500',
      primary: 'bg-primary-500 text-gray-900'
    },
    transparent: {
      true: 'bg-transparent border-gray-900 text-gray-900'
    },
    hover: {
      true: ''
    },
    checked: {
      true: 'bg-primary-100 border border-primary-500 text-primary-500'
    }
  },
  compoundVariants: [
    {
      color: 'gray300',
      hover: true,
      className: 'hover:bg-gray-50'
    },
    {
      color: 'primary',
      checked: true,
      className: 'bg-primary-500 border-primary-500 text-white'
    },
    {
      color: 'primary',
      checked: false,
      className: 'bg-transparent border-gray-300'
    }
  ]
})

const CheckboxInput = defineComponent<CheckboxInputProps>({
  setup(props) {
    const handleClick = () => {
      const nextValue = !isChecked.value

      if (props.reportChange && props.fieldRef) {
        props.reportChange(props.fieldRef, nextValue)
      }

      if (props.dataRef) {
        props.dataRef.setValue(nextValue)
      }
    }

    const isChecked = computed(() => toBoolean(props.value))

    return () => {
      return (
        <div
          style={{
            verticalAlign: 'middle'
          }}
          class={CheckboxInputClass({
            color: (props.variant || 'blue800') as any,
            transparent: !!props.transparent,
            hover: !!props.hover,
            checked: !!isChecked.value
          })}
          onClick={handleClick}
        >
          {isChecked.value && <Icon src={CheckedIcon} size={14} stroke="currentColor" />}
        </div>
      )
    }
  }
})

CheckboxInput.props = [
  'value',
  'type',
  'reportChange',
  'fieldRef',
  'checked',
  'variant',
  'transparent',
  'dataRef',
  'hover'
]

export default CheckboxInput
